import './application.scss';
import '@hotwired/turbo-rails';
import '../controllers';

import * as ActiveStorage from '@rails/activestorage';

ActiveStorage.start();

import '@hotwired/turbo-rails';

import './application.scss';
